import React from 'react';
import PropTypes from 'prop-types';
import { get, isEmpty, noop } from 'lodash';
import Dropdown from '../Dropdown';

class DropdownWrapper extends React.Component {
  handleBlur = e => {
    this.props.field.onBlur(e);
    this.props.onBlur(e);
  };

  handleChange = e => {
    this.props.field.onChange(e);
    this.props.onChange(e);
  };

  render() {
    const { field, form, paths, ...rest } = this.props;

    const isTouched = get(form.touched, field.name);

    const errorMessage = isTouched
      ? isEmpty(paths)
        ? get(form, ['errors', field.name])
        : get(form, ['errors', ...paths])
      : undefined;

    return (
      <Dropdown
        {...rest}
        {...field}
        error={!!errorMessage}
        errorMessage={errorMessage}
        onBlur={this.handleBlur}
        onChange={this.handleChange}
        value={field.value}
      />
    );
  }
}

DropdownWrapper.propTypes = {
  field: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,

  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  paths: PropTypes.array,
};

DropdownWrapper.defaultProps = {
  onBlur: noop,
  onChange: noop,
  paths: [],
};

export default DropdownWrapper;



// WEBPACK FOOTER //
// ./src/modules/common/form/DropdownWrapper.js